<script lang="ts" module>
  /** レッスン一覧の 1 ユニット分 */
  export interface LessonGroup {
    unit: string;
    /** 例「Stage 1 入出力と型」 */
    title: string;
    useCase: string | null;
    lessons: { id: string; title: string }[];
  }
</script>

<script lang="ts">
  /**
   * レッスン一覧 `#/lessons`（参照用）。読了状態・進捗は出さない（docs/decisions/problem-first.md 追記）。
   */
  interface Props {
    groups: LessonGroup[];
  }

  let { groups }: Props = $props();
</script>

<div class="page">
  <div class="page-head">
    <h1 tabindex="-1">レッスン一覧</h1>
    <p class="text-soft small">問題で詰まったときに開く読み物です。</p>
  </div>

  <div class="groups">
    {#each groups as g (g.unit)}
      <section class="panel" aria-labelledby="unit-{g.unit}" data-testid="unit-{g.unit}">
        <h2 id="unit-{g.unit}" class="unit-name">{g.title}</h2>
        {#if g.useCase}<p class="text-soft small">{g.useCase}</p>{/if}
        {#if g.lessons.length > 0}
          <ol class="lessons">
            {#each g.lessons as l (l.id)}
              <li><a href="#/lesson/{l.id}" data-testid="lesson-link">{l.title}</a></li>
            {/each}
          </ol>
        {:else}
          <p class="text-soft small">このユニットのレッスンは準備中です。</p>
        {/if}
      </section>
    {/each}
  </div>
</div>

<style>
  .page-head {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    margin-bottom: var(--space-5);
  }
  .small {
    font-size: var(--fs-sm);
  }
  .groups {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }
  .panel {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .unit-name {
    font-size: var(--fs-lg);
  }
  .lessons {
    margin: 0;
    padding-left: var(--space-5);
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }
  .lessons li {
    min-height: var(--tap-min);
    display: list-item;
    line-height: var(--tap-min);
  }
</style>
